// Mock product catalogue. Multi-language: name & description keyed by language code.
export const PRODUCTS = [
  {
    id: "empanadas-listas",
    category: "empanadas",
    price: 18.9,
    unit: "x12",
    image: "/empanadas-listas.jpg",
    name: {
      es: "Empanadas listas para freír u hornear",
      en: "Empanadas — ready to fry or bake",
      fr: "Empanadas — prêtes à frire ou à cuire",
      de: "Empanadas — fertig zum Backen oder Frittieren",
    },
    description: {
      es: "Empanadas criollas artesanales, repulgue a mano, ultracongeladas. Listas para hornear o freír en minutos.",
      en: "Hand-crimped artisanal criolla empanadas, blast-frozen. Ready to bake or fry in minutes.",
      fr: "Empanadas criollas artisanales, repulgue à la main, ultracongelées. Prêtes à cuire en quelques minutes.",
      de: "Handgemachte criolla-Empanadas mit handgeformtem Rand, schockgefroren. In Minuten fertig.",
    },
  },
  {
    id: "discos-empanadas",
    category: "empanadas",
    price: 6.9,
    unit: "x12",
    image: "/discos-empanadas.jpg",
    name: {
      es: "Discos de empanadas",
      en: "Empanada discs",
      fr: "Disques à empanadas",
      de: "Empanada-Teigblätter",
    },
    description: {
      es: "Masa artesanal ultracongelada, lista para rellenar a tu gusto. 12 discos por envase.",
      en: "Frozen artisanal dough discs — fill them your way. 12 discs per pack.",
      fr: "Disques de pâte artisanale surgelée, à garnir selon votre envie. 12 disques par boîte.",
      de: "Schockgefrorene handwerkliche Teigblätter — füllen Sie sie nach Wunsch. 12 Stück pro Packung.",
    },
  },
  {
    id: "empanada-jyq",
    category: "empanadas",
    price: 17.9,
    unit: "x12",
    image: "https://images.unsplash.com/photo-1604908176997-125f25cc6f6d?w=1200&q=80",
    name: { es: "Empanada Jamón y Queso", en: "Ham & Cheese Empanada", fr: "Empanada Jambon-Fromage", de: "Schinken-Käse-Empanada" },
    description: {
      es: "Clásico imbatible: jamón cocido y queso mozzarella, masa fina y crujiente.",
      en: "Unbeatable classic: cooked ham and mozzarella, thin and crispy pastry.",
      fr: "Le classique imbattable : jambon cuit et mozzarella, pâte fine et croustillante.",
      de: "Unschlagbarer Klassiker: gekochter Schinken und Mozzarella, dünner, knuspriger Teig.",
    },
  },
  {
    id: "dulce-leche",
    category: "dulces",
    price: 9.5,
    unit: "450 g",
    image: "/dulce-leche.jpg",
    name: { es: "Dulce de Leche Tradicional", en: "Traditional Dulce de Leche", fr: "Dulce de Leche Traditionnel", de: "Klassischer Dulce de Leche" },
    description: {
      es: "Receta argentina clásica, denso y de color caramelo. Para untar, rellenar o tomar a cucharadas.",
      en: "Classic Argentine recipe, dense and caramel-coloured. To spread, fill or eat by the spoonful.",
      fr: "Recette argentine classique, dense et caramel. À tartiner, garnir ou déguster à la cuillère.",
      de: "Klassisches argentinisches Rezept, dicht und karamellfarben. Zum Bestreichen, Füllen oder Löffeln.",
    },
  },
  {
    id: "alfajor-maicena",
    category: "dulces",
    price: 12.9,
    unit: "x6",
    image: "/alfajor-maicena.jpg",
    name: { es: "Alfajor de Maicena", en: "Maicena Alfajor", fr: "Alfajor de Maïzena", de: "Maizena Alfajor" },
    description: {
      es: "Dos discos de maicena rellenos de dulce de leche, rebozados en coco rallado.",
      en: "Two cornstarch discs filled with dulce de leche, rolled in grated coconut.",
      fr: "Deux disques de maïzena garnis de dulce de leche, roulés dans la noix de coco râpée.",
      de: "Zwei Maizena-Scheiben gefüllt mit Dulce de Leche, in geraspelter Kokosnuss gewälzt.",
    },
  },
  {
    id: "alfajor-chocolate",
    category: "dulces",
    price: 13.9,
    unit: "x6",
    image: "/alfajor-chocolate.jpg",
    name: { es: "Alfajor de Chocolate", en: "Chocolate Alfajor", fr: "Alfajor au Chocolat", de: "Schokoladen-Alfajor" },
    description: {
      es: "Doble disco de cacao bañado en chocolate negro, con relleno cremoso de dulce de leche. Un clásico irresistible para el café o la merienda.",
      en: "Double cocoa biscuit dipped in dark chocolate, with a creamy dulce de leche filling. An irresistible classic for coffee or afternoon tea.",
      fr: "Double biscuit au cacao enrobé de chocolat noir, garni d'une crème onctueuse de dulce de leche. Un classique irrésistible pour le café ou le goûter.",
      de: "Doppelte Kakaokeks-Scheiben in dunkler Schokolade, gefüllt mit cremigem Dulce de Leche. Ein unwiderstehlicher Klassiker zum Kaffee oder zur Jause.",
    },
  },
  {
    id: "pionono",
    category: "dulces",
    price: 11.9,
    unit: "350 g",
    image: "/pionono.jpg",
    name: { es: "Pionono", en: "Pionono", fr: "Pionono", de: "Pionono" },
    description: {
      es: "Masa esponjosa de bizcochuelo enrollada, lista para rellenar con dulce de leche, crema o ingredientes salados. Versátil base de la repostería rioplatense, ideal para postres y arrollados festivos.",
      en: "Soft, sponge-cake sheet rolled and ready to fill with dulce de leche, cream or savoury ingredients. A versatile staple of Río de la Plata pastry, perfect for desserts and festive roulades.",
      fr: "Feuille de génoise moelleuse enroulée, prête à garnir de dulce de leche, crème ou ingrédients salés. Base polyvalente de la pâtisserie du Río de la Plata, idéale pour desserts et roulés de fête.",
      de: "Weich gerollter Biskuitteig, bereit zum Füllen mit Dulce de Leche, Sahne oder herzhaften Zutaten. Vielseitige Grundlage der Río-de-la-Plata-Konditorei, ideal für Desserts und festliche Roulade.",
    },
  },
  {
    id: "chipa",
    category: "salados",
    price: 8.9,
    unit: "x10",
    image: "/chipa.jpg",
    name: { es: "Chipá", en: "Chipá", fr: "Chipá", de: "Chipá" },
    description: {
      es: "Pancito de queso elaborado con almidón de mandioca y queso semicurado. Sin gluten, dorado por fuera y suave por dentro. Listo para hornear en 15 minutos.",
      en: "Cheese roll made with tapioca starch and semi-cured cheese. Gluten-free, golden outside and soft inside. Oven-ready in 15 minutes.",
      fr: "Petit pain au fromage à base d'amidon de manioc et de fromage demi-affiné. Sans gluten, doré à l'extérieur et moelleux à l'intérieur. Prêt au four en 15 minutes.",
      de: "Käsebrötchen aus Maniokstärke und halbreifem Käse. Glutenfrei, außen goldbraun und innen weich. In 15 Minuten ofenfertig.",
    },
  },
  {
    id: "ginebra-llave",
    category: "bebidas",
    price: 24.9,
    unit: "700 ml · 37,5º",
    image: "/ginebra-llave.jpg",
    name: { es: "Ginebra Llave", en: "Llave Gin", fr: "Gin Llave", de: "Llave Gin" },
    description: {
      es: "Ginebra Especial Llave 1867, receta clásica argentina destilada con enebro y botánicos seleccionados. Botella verde icónica de 700 ml, 37,5º. Ideal para tonics, cócteles clásicos y tragos largos.",
      en: "Llave 1867 Especial Gin, classic Argentine recipe distilled with juniper and selected botanicals. Iconic 700 ml green bottle, 37.5%. Perfect for tonics, classic cocktails and long drinks.",
      fr: "Gin Especial Llave 1867, recette classique argentine distillée avec genièvre et botaniques sélectionnés. Bouteille verte iconique 700 ml, 37,5°. Idéal pour tonics, cocktails classiques et long drinks.",
      de: "Llave 1867 Especial Gin, klassisches argentinisches Rezept, destilliert mit Wacholder und ausgewählten Botanicals. Ikonische grüne 700-ml-Flasche, 37,5%. Ideal für Tonics, klassische Cocktails und Long Drinks.",
    },
  },
  {
    id: "ginebra-llave-black",
    category: "bebidas",
    price: 39.9,
    unit: "700 ml · 44º",
    image: "/ginebra-llave-black.jpg",
    name: {
      es: "Ginebra Llave BLACK Dry Gin",
      en: "Llave BLACK Dry Gin",
      fr: "Gin Llave BLACK Dry Gin",
      de: "Llave BLACK Dry Gin",
    },
    description: {
      es: "Auténtica dry gin de calidad extra premium desde 1867. Lenta destilación en alambiques con una selección de finas hierbas: enebro, semillas, pimientas, calaguala y otras. Botella mate icónica de 700 ml, 44º. Para los amantes de la ginebra clásica argentina.",
      en: "Authentic extra-premium dry gin crafted since 1867. Slow distillation in alembics with a selection of fine herbs: juniper, seeds, peppers, calaguala and more. Iconic matte 700 ml bottle, 44%. For lovers of classic Argentine gin.",
      fr: "Authentique dry gin de qualité extra premium depuis 1867. Distillation lente en alambics avec une sélection de fines herbes : genièvre, graines, poivres, calaguala et autres. Bouteille mate iconique 700 ml, 44°. Pour les amateurs de gin argentin classique.",
      de: "Authentischer Extra-Premium Dry Gin seit 1867. Langsame Destillation in Brennblasen mit einer Auswahl feiner Kräuter: Wacholder, Samen, Pfeffer, Calaguala und mehr. Ikonische matte 700-ml-Flasche, 44%. Für Liebhaber des klassischen argentinischen Gins.",
    },
  },
];

export const EVENTS_DATA = [
  {
    id: "salon-gourmet-2026",
    date: { d: "12", m: "Abr", y: "2026" },
    name: { es: "Salón Gourmet Madrid", en: "Madrid Gourmet Fair", fr: "Salon Gourmet de Madrid", de: "Gourmet-Messe Madrid" },
    location: "IFEMA · Madrid, España",
    image: "https://images.unsplash.com/photo-1599033183537-54ff77f58f75?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    desc: {
      es: "Estaremos en el pabellón internacional con cata de empanadas y degustación de Malbec.",
      en: "We'll be in the international hall with empanada tasting and Malbec sampling.",
      fr: "Présents au hall international avec dégustation d'empanadas et de Malbec.",
      de: "Wir sind in der internationalen Halle mit Empanada- und Malbec-Verkostung.",
    },
  },
  {
    id: "feria-paris-2026",
    date: { d: "07", m: "Jun", y: "2026" },
    name: { es: "Feria Internacional de París", en: "Paris International Fair", fr: "Foire Internationale de Paris", de: "Internationale Messe Paris" },
    location: "Porte de Versailles · Paris, France",
    image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1600&q=80",
    desc: {
      es: "Tres días de cocina argentina en vivo, charlas con productores y catas guiadas.",
      en: "Three days of live Argentine cooking, producer talks and guided tastings.",
      fr: "Trois jours de cuisine argentine en direct, rencontres et dégustations guidées.",
      de: "Drei Tage argentinische Küche live, Produzentengespräche und geführte Verkostungen.",
    },
  },
  {
    id: "anuga-2026",
    date: { d: "10", m: "Oct", y: "2026" },
    name: { es: "ANUGA Colonia", en: "ANUGA Cologne", fr: "ANUGA Cologne", de: "ANUGA Köln" },
    location: "Koelnmesse · Köln, Deutschland",
    image: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=1600&q=80",
    desc: {
      es: "Presentación de la nueva línea de empanadas premium para el mercado europeo.",
      en: "Launch of the new premium empanada line for the European market.",
      fr: "Lancement de la nouvelle ligne d'empanadas premium pour le marché européen.",
      de: "Vorstellung der neuen Premium-Empanada-Linie für den europäischen Markt.",
    },
  },
  {
    id: "noche-tango-2026",
    date: { d: "22", m: "Nov", y: "2026" },
    name: { es: "Noche del Tango y Empanada", en: "Tango & Empanada Night", fr: "Soirée Tango & Empanada", de: "Tango- und Empanada-Nacht" },
    location: "Mercado de San Antón · Madrid",
    image: "https://images.unsplash.com/photo-1571197119282-7c4e2bb0ee5d?w=1600&q=80",
    desc: {
      es: "Una velada con música, baile y la mejor cocina criolla en pleno corazón de Chueca.",
      en: "An evening with music, dance and the best criollo cooking in the heart of Chueca.",
      fr: "Une soirée musique, danse et la meilleure cuisine criolla au cœur de Chueca.",
      de: "Ein Abend mit Musik, Tanz und der besten criollo-Küche im Herzen von Chueca.",
    },
  },
];

export const BRAND_CONTACT = {
  phone: "+34 646 664 977",
  whatsapp: "34646664977",
  email: "contacto@lacriollita.eu",
  address: "C/ Camí de Muntanya, 7 – 1º · Polígono Industrial de Marratxí · 07141 Mallorca (España)",
  addressShort: "Camí de Muntanya, 7 · 07141 Marratxí · Mallorca",
  mapsQuery: "Camí+de+Muntanya+7,+07141+Marratxí,+Mallorca,+España",
  mapsLink: "https://www.google.com/maps/place/Cam%C3%AD+de+Muntanya,+7,+07141+Marratx%C3%AD,+Illes+Balears",
  instagram: "https://instagram.com/lacriollita",
  facebook: "https://facebook.com/lacriollita",
};
